export default __webpack_public_path__ + "static/favicon-5b7036e1c12f4dabeac841f4e3385817.ico";